import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PaymentModeContext = createContext();

export function PaymentModeProvider({ children }) {
  const [siteSettings, setSiteSettings] = useState({
    enabled: false,
    auth_required: true,
    loading: true
  });

  const loadSettings = async () => {
    try {
      const response = await axios.get(`${API}/site-settings`);
      setSiteSettings({
        enabled: response.data.payment_enabled,
        auth_required: response.data.auth_required,
        loading: false
      });
    } catch (_) {
      setSiteSettings({ enabled: false, auth_required: true, loading: false });
    }
  };

  useEffect(() => {
    loadSettings();
    const interval = setInterval(loadSettings, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <PaymentModeContext.Provider value={siteSettings}>
      {children}
    </PaymentModeContext.Provider>
  );
}

export function usePaymentMode() {
  const context = useContext(PaymentModeContext);
  if (context === undefined) {
    return { enabled: false, auth_required: true, loading: true };
  }
  return context;
}
